import { BUTTON_BORDER_RADIUS } from "Constants/theme";
import { skeletonGradient } from "Constants/ColourConstants";

export const styles = {
  statusStack: { gap: 0.5, alignItems: "center", py: 0.5 },
  tooltipSlotProps: {
    popper: {
      modifiers: [{ name: "offset", options: { offset: [0, -8] } }], // brings the arrow to the status box
    },
  },
  statusTextHidden: {
    visibility: "hidden",
    whiteSpace: "nowrap",
  },
  statusSkeleton: {
    borderRadius: BUTTON_BORDER_RADIUS,
    position: "absolute",
    inset: 0,
    transform: "none",
    backgroundImage: "inherit",
    "&::after": { background: skeletonGradient },
  },
};
